<style lang="scss" scoped>
/deep/ .comp-edit-work-dialog {
    max-width: 400px;
}
</style>

<template>
    <div class="comp-edit-work">
        <el-dialog title="员工配置" custom-class="c-el-dialog comp-edit-work-dialog" :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false">
            <el-form :model="dialogData" :rules="formRules" :ref="formRefName" label-width="100px" size="small">
                <el-col :xs="24">
                    <el-form-item label="员工姓名" prop="name">
                        <el-autocomplete class="c-pw100" v-model="dialogData.name" placeholder="请输入姓名"
                            :disabled="dialogType === createOrUpdate[1]"
                            :trigger-on-focus="false"
                            :fetch-suggestions="querySearchAsync"
                            @select="handleSelect">
                            <template slot-scope="{ item }">
                                <div>
                                    <span class="fl">{{ item.name }}</span>
                                    <span class="fr">{{ item.tel }}</span>
                                </div>
                            </template>      
                        </el-autocomplete>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="联系电话" prop="tel">
                        <el-input v-model="dialogData.tel" placeholder="请输入联系电话" :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="归属平台" prop="platform">
                        <el-select class="c-pw100" v-model="dialogData.platform" placeholder="请选择归属平台" filterable @change="changePlatform">
                            <el-option v-for="item in allPlatforms" :key="'platform-' + item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="归属服务区" prop="area">
                        <el-select class="c-pw100" v-model="dialogData.area" placeholder="请选择归属服务区" filterable>
                            <el-option v-for="item in allServiceAreas" :key="'day-work-' + item.id" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24">
                    <el-form-item label="员工身份">
                        <el-select class="c-pw100" v-model="dialogData.role" placeholder="请选择员工身份" clearable>
                            <el-option v-for="item in arrEmployeeRole" :key="'role-' + item.value" :label="item.desc" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
            <span slot="footer">
                <el-button size="small" @click="_close()">取消</el-button>
                <el-button size="small" type="primary" @click="_save()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import configMixins from "@/mixins/config"
import enumConfigs from "@/mixins/enumConfigs"
import * as funEmployees from '@/api/employees'
import * as funAll from '@/api/all'
export default {
    name: "compEditWork",
    mixins: [configMixins, enumConfigs],
    data() {
        return {
            showDialog: false,
            defaultDialogData: {
                name: "",
                tel: "",
                platform: "",
                role: null,
                area: ""
            },
            dialogData: {},
            dialogType: "", 
            formRefName: "refEditWork",
            formRules: {
                name: [{ required: true, message: '请输入姓名', trigger: ['blur']}],
                tel: [{ required: true, message: '请输入联系方式', trigger: ['blur']}],
                platform: [{ required: true, message: '请选择归属平台', trigger: ['blur', 'change']}],
                area: [{ required: true, message: '请选择归属服务区', trigger: ['blur', 'change']}]
            },
            // 所有的平台
            allPlatforms: [],
            // 所有的服务区
            allServiceAreas: []
        }
    },
    // computed: {
    //     allServiceAreas() {
    //         let areas = JSON.parse(JSON.stringify(this.$store.getters.serviceAreas))
    //         // 根据enableSpider是否为true来排序到前面
    //         return areas.sort((a, b) => {
    //             if (a.enableSpider && !b.enableSpider) {
    //                 return -1
    //             } else if (!a.enableSpider && b.enableSpider) {
    //                 return 1
    //             } else {
    //                 return 0
    //             }
    //         })
    //     }
    // },
    methods: {
        async open(row) {
            // 先查询所有的平台
            await this.queryAllPlatforms()
            this.dialogData = JSON.parse(JSON.stringify(this.defaultDialogData))
            if (row && row.tel) {
                this.dialogType = this.createOrUpdate[1]
                this.dialogData = JSON.parse(JSON.stringify(row))
                // 编辑
            } else {
                this.dialogType = this.createOrUpdate[0]
            }
            // 查询所有的服务区
            await this.queryAllServiceAreas()
            this.showDialog = true
        },
        // 获取所有的平台
        async queryAllPlatforms() {
            await funAll.AllPlatforms().then(res => {
                this.allPlatforms = res || []
            })
        },
        // 获取所有服务区
        async queryAllServiceAreas() {
            await funAll.AllServiceAreas({ platform: this.dialogData.platform || "", isActive: true }).then(res => {
                this.allServiceAreas = res || []
                this.allServiceAreas.sort((a, b) => {
                    if (a.enableSpider && !b.enableSpider) {
                        return -1
                    } else if (!a.enableSpider && b.enableSpider) {
                        return 1
                    } else {
                        return 0
                    }
                })
            })
        },
        // 平台改变时，查询所有的服务区
        changePlatform() {
            this.dialogData.area = ""
            this.queryAllServiceAreas()
        },
        querySearchAsync(queryString, cb) {
            if (!queryString) {
                return false
            }
            var params = {
                name: queryString
            }
            funEmployees.SearchEmployeeConfigs(params).then(res => {
                cb(res)
            })
        },
        handleSelect(item) {
            this.dialogData.name = item.name
            this.dialogData.tel = item.tel
        },
        _save() {
            this.$refs[this.formRefName].validate(valid => {
                if (valid) {
                    this.dialogData.tel = this.dialogData.tel.trim()
                    this.dialogData.name = this.dialogData.name.trim()
                    this.dialogData.role = this.dialogData.role || null
                    window.$common.fullLoading()
                    funEmployees.SetEmployeeDayWorkConfigs(this.dialogData).then(() => {
                        this.commonSuccess()
                    })
                }
            })
        },
        _close() {
            this.showDialog = false
            this.$nextTick(() => {
                if (this.$refs[this.formRefName]) {
                    this.$refs[this.formRefName].resetFields()
                }
            })
        },
        commonSuccess(val) {
            let tips = val || "操作成功!"
            this.alert(tips).then(() => {
                window.$common.closeFullLoading()
                this._close()
                this.refreshData()
            })
        },
        refreshData() {
            this.$emit("refreshData", this.dialogData)
        }
    }
}
</script>